import React from "react";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Chart } from 'primereact/chart';

import { formatCurrency } from '../../service/format';

export default function RankingCategoryExpense(props){
    var suppliers = (props?.suppliers || []).sort((a, b) => b.amount - a.amount);
    var categories = (props?.categories || []).sort((a, b) => b.amount - a.amount);

    var valueTotalSuppliers = suppliers.reduce((previous, { amount }) => previous + amount, 0);
    var valueTotal = categories.reduce((previous, { amount }) => previous + amount, 0);

    var chartData = {
        labels: categories?.map(({ name }) => name),
        datasets: [{
            data: categories?.map(({ amount }) => amount ),
            backgroundColor: [
                "#FF6384",
                "#36A2EB",
                "#FFCE56",
                "#66BB6A",
                "#26C6DA",
                "#7E57C2"
            ],
        }]
    }

    var chartOptions = {
        indexAxis: 'y',
        maintainAspectRatio: false,
        aspectRatio: .8,
        plugins: {
            legend: {
                display: false
            }
        },
    }

    return (
        <>
            <div className="col-12 xl:col-7" >
                <div className="card" style={{ height: "100%" }}>
                    <div className="flex justify-content-between align-items-center mb-5">
                        <h5>Categoria de Despesas</h5>
                    </div>
                    <Chart style={{ position: 'relative', width: '90%', marginLeft: "5%" }} type="bar" data={chartData} options={chartOptions} />
                </div>
            </div>
            <div className="col-12 xl:col-6">
                <div className="card" style={{ minHeight: "672px", height: "100%" }}>
                    <div className="flex justify-content-between align-items-center mb-5">
                        <h5>Ranking de categoria de Despesas</h5>
                    </div>
                    <DataTable value={categories?.map(({ name, amount }, index) => {
                        const percent = (amount / valueTotal * 100).toFixed(2);
                        return {
                            category: String(index + 1).padStart(2, '0') + "º - " + name,
                            amount: formatCurrency(amount, true),
                            percent: formatCurrency(parseFloat(percent), false, 2).toLocaleString().padStart(5, "0") + '%'
                        }
                    })} rows={10} paginator emptyMessage="Nenhum registro." responsiveLayout="scroll">
                        <Column field="category" header="Categoria"></Column>
                        <Column field="amount" header="Valor"></Column>
                        <Column field="percent" style={{ whiteSpace: "nowrap" }} header="Percentual"></Column>
                    </DataTable>
                </div>
            </div>
            <div className="col-12 xl:col-6">
                <div className="card" style={{ minHeight: "672px", height: "100%" }}>
                    <div className="flex justify-content-between align-items-center mb-5">
                        <h5>Ranking de despesas por Fornecedores</h5>
                    </div>
                    <DataTable value={suppliers?.map(({ name, amount }, index) => {
                        const percent = (amount / valueTotalSuppliers * 100).toFixed(2);
                        return {
                            supplier: String(index + 1).padStart(2, '0') + "º - " + name,
                            amount: formatCurrency(amount, true),
                            percent: formatCurrency(parseFloat(percent), false, 2).toLocaleString().padStart(5, "0") + '%'
                        }
                    })} rows={10} paginator emptyMessage="Nenhum registro." responsiveLayout="scroll">
                        <Column field="supplier" header="Fornecedor"></Column>
                        <Column field="amount" header="Valor"></Column>
                        <Column field="percent" style={{ whiteSpace: "nowrap" }} header="Percentual"></Column>
                    </DataTable>
                </div>
            </div>
            
           
        </>
    )
}